const WORD_PATTERN = /^\p{L}+(?:[’'-]\p{L}+)*$/u;

function normalizeWord(value: string) {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’]/g, "'")
    .toLocaleLowerCase();
}

function sentenceContainingOffset(text: string, offset: number) {
  const starts = [...text.matchAll(/(?:^|[.!?]\s+)([^.!?]+[.!?]?)/g)];
  const match = starts.find((candidate) => {
    const start = (candidate.index || 0) + (candidate[0].length - candidate[1].length);
    return offset >= start && offset <= start + candidate[1].length;
  });
  return (match?.[1] || text).trim();
}

export function SelectableProse({
  text,
  surfaceId,
}: {
  text: string;
  surfaceId: string;
}) {
  const parts = text.split(/(\p{L}+(?:[’'-]\p{L}+)*)/gu);
  const partsWithOffsets = parts.map((part, index) => ({
    index,
    offset: parts.slice(0, index).join("").length,
    part,
  }));
  return (
    <>
      {partsWithOffsets.map(({ index, offset, part }) => {
        if (!WORD_PATTERN.test(part)) return part;
        const key = normalizeWord(part);
        const tokenId = `surface-${surfaceId}-t${index}`;
        return (
          <span
            key={tokenId}
            className="selectable-word universal-selectable-word"
            data-selectable-word="true"
            data-selection-surface="universal"
            data-word-key={key}
            data-display-word={part}
            data-token-id={tokenId}
            data-paragraph-id={`surface-${surfaceId}`}
            data-sentence={sentenceContainingOffset(text, offset)}
            role="button"
            tabIndex={0}
            aria-label={`Explain ${part}`}
          >
            {part}
          </span>
        );
      })}
    </>
  );
}
